import React, {createContext, useReducer} from 'react';
import {updateObject} from '../../Utils';
import {addToRanking} from '../../store/storeRanking';

const ContextPlayer = createContext();

function playerReducer(state, action){
  switch (action.type) {
    case "UpdateMoves":
      return updateObject(state,{moves: state.moves + 1});

    case "UpdateTimeout":
      return updateObject(state,{timeout: state.timeout+ action.timeout});

    case "UpdatePlaying":
      return updateObject(state,{playing: !state.playing});

    case "UpdateInitGame":
      return updateObject(state,{initGame: !state.initGame});

    case "NewGame":
      return updateObject(state,{playing: false, initGame:false});

    case "UpdateData":
      const newData = updateObject(state,action);
      addToRanking(newData);
      return newData;
      
    default:
      return state;
  }
};

function PlayerProvider({gameName, children}){
  const [state, dispatch] = useReducer(playerReducer,{name:"", timeout:0, moves:0, game: gameName.gameName, playing:false, initGame: false });

  return (
    <ContextPlayer.Provider value={{state, dispatch}}>
      {children}
    </ContextPlayer.Provider>
  );
}

export {PlayerProvider, ContextPlayer};
